export const Theme = {
  colors: {
    primary: "#a3154c",
    secondary: "#6a6a6a",
    accentGreen: "#32a852",
    accentRed: "#eb4034"
  }
}